import React from 'react';
import style from './RadioButton.module.scss';

class RadioButton extends React.Component {
  render() {
    const { text, onChange, isChecked, className } = this.props;

    return (
        <div className={`d-inline-flex justify-content-center align-items-center ${style.item} ${isChecked ? style.checked : ''} ${className}`} onClick={() => onChange(!isChecked)}>
          <label>{text}</label>
        </div>
    );
  }
}

export default RadioButton;
